import { freeUserUpgradeStep } from '../utils';

export const partnershipsTour = {
  tourKey: 'partnerships',
  conditions: {
    orgTypes: ['business', 'npo'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      target: '[data-tour="partnerships-list"]',
      title: 'tours.partnerships.list.title',
      content: 'tours.partnerships.list.content',
      placement: 'top',
    },
    {
      target: '[data-tour="partnership-status"]',
      title: 'tours.partnerships.tabs.title',
      content: 'tours.partnerships.tabs.content',
      placement: 'bottom',
    },
    freeUserUpgradeStep,
  ],
};
